import { render } from "./SpmBadge.vue?vue&type=template&id=1ac0c3b2&scoped=true"
import script from "./SpmBadge.vue?vue&type=script&lang=ts"
export * from "./SpmBadge.vue?vue&type=script&lang=ts"

import "./SpmBadge.vue?vue&type=style&index=0&id=1ac0c3b2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ac0c3b2"

export default script